import { Card, CardHeader, CardTitle } from '@/components'

import { Equipamento } from '../entities/equipamento'
import { ItemField } from './utils/item-field'

export function EquipamentoDetailsCard({
  equipamento,
}: {
  equipamento: Equipamento
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Detalhes do equipamento</CardTitle>
      </CardHeader>

      <div className="space-y-4">
        <ItemField label="Nome">
          <span className="font-bold">{equipamento.nome}</span>
        </ItemField>
        <ItemField label="Acessórios">
          {equipamento.acessorios ?? 'Não informado'}
        </ItemField>
        <ItemField label="Nº de identificação">
          {equipamento.numSerie ?? 'Não informado'}
        </ItemField>
      </div>
    </Card>
  )
}
